// src/services/warranty.service.js
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5172/api";

export const warrantyService = {
  /**
   * Check product warranty status by serial number
   * @param {string} serialNumber 
   * @returns {Promise<Object>} Warranty details
   */
  async checkWarranty(serialNumber) {
    // We don't need auth headers because this is a public verification page
    const res = await axios.get(`${API_BASE_URL}/warranty/check/${serialNumber}`);
    return res.data;
  }
};